




















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Page } from "yellowfin-ui-lib";
import { Attivita } from "@/data/models/attivita.model";

@Component({})
export default class AttivitaList extends Vue {
  eventUrl: string = process.env.VUE_APP_EVENT_URL as string;

  now: Date = new Date();

  @Prop() data!: Attivita[];
  @Prop() page!: Page;
  @Prop() loading!: boolean;

  base = "";
  firstload = true;

  @Watch("data")
  onDataChange() {
    this.firstload = false;
  }

  onPageChange(page: number) {
    this.$emit("page", page);
  }

  beforeMount() { }
}
